import { Fade, TooltipProps, tooltipClasses, styled, Tooltip } from '@mui/material';

const InfoTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} slots={{ transition: Fade }} slotProps={{ transition: { timeout: 150 } }} />
))({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#FFFFFF',
    color: '#344054',
    border: '1px solid #EAECF0',
    borderRadius: 10,
    boxShadow: '0 12px 24px -4px rgba(16, 24, 40, 0.12), 0 4px 8px -2px rgba(16, 24, 40, 0.06)',
    padding: '12px 14px',
    fontSize: 13,
    lineHeight: 1.5,
    fontWeight: 400,
    maxWidth: 300,
  },
});

export default InfoTooltip;
